import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=539065ee&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=539065ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539065ee",
  null
  
)

export default component.exports